import apiClient, { getApiErrorInfo } from './api';

export interface ContactUsRequest {
  fullName: string;
  email: string;
  topic: string;
  message: string;
}

export interface ContactUsResponse {
  message?: string;
}

export interface ContactUsResult {
  success: boolean;
  status: number | null;
  message: string;
  errorCode?: string;
}

const getContactUsMessage = (status: number | null, fallbackMessage: string): string => {
  switch (status) {
    case 400:
      return 'Your request is missing required details. Please review and try again.';
    case 401:
      return 'Your session has expired. Please sign in and submit your message again.';
    case 403:
      return 'You do not have permission to send support requests from this account.';
    case 404:
      return 'Support endpoint was not found. Please refresh and try again.';
    case 429:
      return 'Too many requests were sent. Please wait a moment and try again.';
    case 500:
      return 'Support service is temporarily unavailable. Please try again shortly.';
    default:
      return fallbackMessage;
  }
};

class EmailService {
  async sendContactUsMessage(payload: ContactUsRequest): Promise<ContactUsResult> {
    try {
      const response = await apiClient.post<ContactUsResponse>('/api/email/contact-us', payload);
      const responseMessage =
        typeof response.data?.message === 'string' && response.data.message.trim()
          ? response.data.message
          : 'Thank you for contacting CPAx Academy Support. We received your request and will follow up shortly.';

      return {
        success: true,
        status: response.status,
        message: responseMessage,
      };
    } catch (error: unknown) {
      const apiError = getApiErrorInfo(error);
      return {
        success: false,
        status: apiError.status,
        message: getContactUsMessage(apiError.status, apiError.message),
        errorCode: apiError.code,
      };
    }
  }
}

export const emailService = new EmailService();
export default emailService;
